module.exports = __webpack_public_path__ + "static/media/Mockup.50cff939.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Mockup.png
// module id = 229
// module chunks = 0